app.component("visionForm", {
	templateUrl: "app/src/js/components/visionRefraction/visionForm.html",
	controller: "visionFormController",
	bindings: {
		data: "=",
		otherEye: "=",
		eyeTitle: "@",
		hasDifference: "=",
		isAcuityVisible: "=",
		isLinkHidden: "=",
		preset: "="
	},
});

app.controller("visionFormController", [
	"$scope",
	"LETTER",
	"CYL",
	"DEVICE",
	"$timeout",
	"LENS_STATUS",
	"NUCLEAR_OPALESCENCE",
	"NUCLEAR_COLOUR",
	"CORTICAL",
	"POST_SUBCAPSULAR",
	"PUPIL_SIZE",
	"VISUAL_POTENTIAL",
	"LINE",
	function ($scope, LETTER, CYL, DEVICE, $timeout,LENS_STATUS, NUCLEAR_OPALESCENCE, NUCLEAR_COLOUR, CORTICAL, POST_SUBCAPSULAR, PUPIL_SIZE, VISUAL_POTENTIAL, LINE) {
		$scope.visualacuityline =  LINE;
		$scope.letter = LETTER;
		$scope.cyl = CYL;
		$scope.device = DEVICE;
		$scope.lens_status = LENS_STATUS;
		$scope.nuclear_opalescence = NUCLEAR_OPALESCENCE;
		$scope.nuclear_colour = NUCLEAR_COLOUR;
		$scope.cortical = CORTICAL;
		$scope.post_subcapsular = POST_SUBCAPSULAR;
		$scope.pupil_size = PUPIL_SIZE;
		$scope.visual_potential = VISUAL_POTENTIAL;

		// Prism bases, kept apart by direction, as the server stores them.
		$scope.horizontal_bases = [
			{ name: "In (BI)", value: "BASE_IN" },
			{ name: "Out (BO)", value: "BASE_OUT" },
		];
		$scope.vertical_bases = [
			{ name: "Up (BU)", value: "BASE_UP" },
			{ name: "Down (BD)", value: "BASE_DOWN" },
		];

		$scope.isNumber = function (value) {
			return (value === 0 || value !=null)
		}

		$scope.refractionCylinderOnChange = function () {
			if ($scope.$ctrl.data.cyl === 0){
				$scope.$ctrl.data.axis = 0;
			}
		}

		$scope.hasPrism = function () {
			return !!($scope.$ctrl.data.horizontal_prism || $scope.$ctrl.data.vertical_prism);
		};

		// A cleared prism drops its base, and with no prism left in this eye, where it was measured.
		$scope.horizontalPrismOnChange = function () {
			if (!$scope.$ctrl.data.horizontal_prism) {
				$scope.$ctrl.data.horizontal_prism_base = null;
			}
			clearPrismDistance();
		};

		$scope.verticalPrismOnChange = function () {
			if (!$scope.$ctrl.data.vertical_prism) {
				$scope.$ctrl.data.vertical_prism_base = null;
			}
			clearPrismDistance();
		};

		function clearPrismDistance() {
			if (!$scope.hasPrism()) {
				$scope.$ctrl.data.prism_distance = null;
			}
		}

		// The adds are the same in both eyes 95% of the time, so they can be copied across.
		$scope.copyAddsToOtherEye = function () {
			const other = $scope.$ctrl.otherEye;
			if (!other) return;
			other.refraction_add = $scope.$ctrl.data.refraction_add;
			other.refraction_intermediate_add = $scope.$ctrl.data.refraction_intermediate_add;
			// The adds only show on a subjective refraction, so the copy stays visible.
			if (other.auto_refraction !== false) {
				other.auto_refraction = false;
			}
		};

		$scope.canCopyAdds = function () {
			return !!$scope.$ctrl.otherEye &&
				($scope.isNumber($scope.$ctrl.data.refraction_add) || $scope.isNumber($scope.$ctrl.data.refraction_intermediate_add));
		};
	},
]);
